import { MonthlyValues, Indicators } from "./types";

export function getDivergentMonthlyValues(
  currentMonthlyValues?: MonthlyValues | null,
  newMonthlyValues?: MonthlyValues | null,
): {
  label: string;
  currentValue: number | string;
  newValue: number | string;
}[] {
  if (!currentMonthlyValues || !newMonthlyValues) return [];
  const divergentMonthsValues: {
    label: string;
    currentValue: number | string;
    newValue: number | string;
  }[] = [];
  if (
    currentMonthlyValues.jan?.toString() !== newMonthlyValues.jan?.toString()
  ) {
    divergentMonthsValues.push({
      label: "Janeiro",
      currentValue: currentMonthlyValues.jan ?? "Não informado",
      newValue: newMonthlyValues.jan ?? "Não informado",
    });
  }
  if (
    currentMonthlyValues.feb?.toString() !== newMonthlyValues.feb?.toString()
  ) {
    divergentMonthsValues.push({
      label: "Fevereiro",
      currentValue: currentMonthlyValues.feb ?? "Não informado",
      newValue: newMonthlyValues.feb ?? "Não informado",
    });
  }
  if (
    currentMonthlyValues.mar?.toString() !== newMonthlyValues.mar?.toString()
  ) {
    divergentMonthsValues.push({
      label: "Março",
      currentValue: currentMonthlyValues.mar ?? "Não informado",
      newValue: newMonthlyValues.mar ?? "Não informado",
    });
  }
  if (
    currentMonthlyValues.apr?.toString() !== newMonthlyValues.apr?.toString()
  ) {
    divergentMonthsValues.push({
      label: "Abril",
      currentValue: currentMonthlyValues.apr ?? "Não informado",
      newValue: newMonthlyValues.apr ?? "Não informado",
    });
  }
  if (
    currentMonthlyValues.may?.toString() !== newMonthlyValues.may?.toString()
  ) {
    divergentMonthsValues.push({
      label: "Maio",
      currentValue: currentMonthlyValues.may ?? "Não informado",
      newValue: newMonthlyValues.may ?? "Não informado",
    });
  }
  if (
    currentMonthlyValues.jun?.toString() !== newMonthlyValues.jun?.toString()
  ) {
    divergentMonthsValues.push({
      label: "Junho",
      currentValue: currentMonthlyValues.jun ?? "Não informado",
      newValue: newMonthlyValues.jun ?? "Não informado",
    });
  }
  if (
    currentMonthlyValues.jul?.toString() !== newMonthlyValues.jul?.toString()
  ) {
    divergentMonthsValues.push({
      label: "Julho",
      currentValue: currentMonthlyValues.jul ?? "Não informado",
      newValue: newMonthlyValues.jul ?? "Não informado",
    });
  }
  if (
    currentMonthlyValues.aug?.toString() !== newMonthlyValues.aug?.toString()
  ) {
    divergentMonthsValues.push({
      label: "Agosto",
      currentValue: currentMonthlyValues.aug ?? "Não informado",
      newValue: newMonthlyValues.aug ?? "Não informado",
    });
  }
  if (
    currentMonthlyValues.sep?.toString() !== newMonthlyValues.sep?.toString()
  ) {
    divergentMonthsValues.push({
      label: "Setembro",
      currentValue: currentMonthlyValues.sep ?? "Não informado",
      newValue: newMonthlyValues.sep ?? "Não informado",
    });
  }
  if (
    currentMonthlyValues.oct?.toString() !== newMonthlyValues.oct?.toString()
  ) {
    divergentMonthsValues.push({
      label: "Outubro",
      currentValue: currentMonthlyValues.oct ?? "Não informado",
      newValue: newMonthlyValues.oct ?? "Não informado",
    });
  }
  if (
    currentMonthlyValues.nov?.toString() !== newMonthlyValues.nov?.toString()
  ) {
    divergentMonthsValues.push({
      label: "Novembro",
      currentValue: currentMonthlyValues.nov ?? "Não informado",
      newValue: newMonthlyValues.nov ?? "Não informado",
    });
  }
  if (
    currentMonthlyValues.dec?.toString() !== newMonthlyValues.dec?.toString()
  ) {
    divergentMonthsValues.push({
      label: "Dezembro",
      currentValue: currentMonthlyValues.dec ?? "Não informado",
      newValue: newMonthlyValues.dec ?? "Não informado",
    });
  }

  return divergentMonthsValues;
}
export function checkDivergentSingleValues(
  currentValue?: number | string | null,
  newValue?: number | string | null,
) {
  if (currentValue?.toString() !== newValue?.toString()) {
    if (
      (newValue == null || newValue == undefined) &&
      (currentValue == null || currentValue == undefined)
    )
      return null;
    else return newValue;
  }
}
export function getDivergentSingleValuesIndicators(
  currentIndicators?: Indicators,
  newIndicators?: Indicators,
) {
  if (!currentIndicators || !newIndicators) return {};
  const divergentIndicators: Indicators = {};
  if (
    checkDivergentSingleValues(
      currentIndicators.totalPower,
      newIndicators.totalPower,
    )
  ) {
    divergentIndicators.totalPower = newIndicators.totalPower;
  }
  if (
    checkDivergentSingleValues(
      currentIndicators.opticalLossesPercentage,
      newIndicators.opticalLossesPercentage,
    )
  ) {
    divergentIndicators.opticalLossesPercentage =
      newIndicators.opticalLossesPercentage;
  }
  if (
    checkDivergentSingleValues(
      currentIndicators.conversionLossesPercentage,
      newIndicators.conversionLossesPercentage,
    )
  ) {
    divergentIndicators.conversionLossesPercentage =
      newIndicators.conversionLossesPercentage;
  }
  if (
    checkDivergentSingleValues(
      currentIndicators.inverterLossesPercentage,
      newIndicators.inverterLossesPercentage,
    )
  ) {
    divergentIndicators.inverterLossesPercentage =
      newIndicators.inverterLossesPercentage;
  }
  if (
    checkDivergentSingleValues(
      currentIndicators.transformerLossesPercentage,
      newIndicators.transformerLossesPercentage,
    )
  ) {
    divergentIndicators.transformerLossesPercentage =
      newIndicators.transformerLossesPercentage;
  }
  if (
    checkDivergentSingleValues(
      currentIndicators.modulesArea,
      newIndicators.modulesArea,
    )
  ) {
    divergentIndicators.modulesArea = newIndicators.modulesArea;
  }
  if (
    checkDivergentSingleValues(currentIndicators.kwPeak, newIndicators.kwPeak)
  ) {
    divergentIndicators.kwPeak = newIndicators.kwPeak;
  }
  if (
    checkDivergentSingleValues(
      currentIndicators.variance,
      newIndicators.variance,
    )
  ) {
    divergentIndicators.variance = newIndicators.variance;
  }
  if (
    checkDivergentSingleValues(
      currentIndicators.efficiency,
      newIndicators.efficiency,
    )
  ) {
    divergentIndicators.efficiency = newIndicators.efficiency;
  }

  return divergentIndicators;
}

export function checkIfIndicatorsAreDifferent(
  fromScreen: "PVSystForm" | "MWValueForm",
  currentIndicators?: Indicators,
  newIndicators?: Indicators,
) {
  if (!currentIndicators || !newIndicators) return false;
  if (fromScreen === "PVSystForm") {
    const divergentSingleValueIndicators = getDivergentSingleValuesIndicators(
      currentIndicators,
      newIndicators,
    );
    if (Object.keys(divergentSingleValueIndicators).length > 0) return true;
    const divergentPredictedEnergy = getDivergentMonthlyValues(
      currentIndicators.predictedEnergy,
      newIndicators.predictedEnergy,
    );
    if (divergentPredictedEnergy.length > 0) return true;
    const divergentIrradiance = getDivergentMonthlyValues(
      currentIndicators.irradiance,
      newIndicators.irradiance,
    );
    if (divergentIrradiance.length > 0) return true;
    const divergentGlobInc = getDivergentMonthlyValues(
      currentIndicators.globInc,
      newIndicators.globInc,
    );
    if (divergentGlobInc.length > 0) return true;
    const divergentPR = getDivergentMonthlyValues(
      currentIndicators.pr,
      newIndicators.pr,
    );
    if (divergentPR.length > 0) return true;
    const divergentOpticalLoss = getDivergentMonthlyValues(
      currentIndicators.pvSystExpectedOpticalLoss,
      newIndicators.pvSystExpectedOpticalLoss,
    );
    if (divergentOpticalLoss.length > 0) return true;
    const divergentConversionLoss = getDivergentMonthlyValues(
      currentIndicators.pvSystExpectedConversionLoss,
      newIndicators.pvSystExpectedConversionLoss,
    );
    if (divergentConversionLoss.length > 0) return true;
    const divergentInverterLoss = getDivergentMonthlyValues(
      currentIndicators.pvSystExpectedInverterLoss,
      newIndicators.pvSystExpectedInverterLoss,
    );
    if (divergentInverterLoss.length > 0) return true;
    const divergentTransformerLoss = getDivergentMonthlyValues(
      currentIndicators.pvSystExpectedTransformerLoss,
      newIndicators.pvSystExpectedTransformerLoss,
    );
    if (divergentTransformerLoss.length > 0) return true;
    const divergentSystem = getDivergentMonthlyValues(
      currentIndicators.pvSystExpectedSystem,
      newIndicators.pvSystExpectedSystem,
    );
    if (divergentSystem.length > 0) return true;
    const divergentContractual = getDivergentMonthlyValues(
      currentIndicators.pvSystExpectedContractual,
      newIndicators.pvSystExpectedContractual,
    );
    if (divergentContractual.length > 0) return true;
    const divergentInverter = getDivergentMonthlyValues(
      currentIndicators.pvSystExpectedInverter,
      newIndicators.pvSystExpectedInverter,
    );
    if (divergentInverter.length > 0) return true;
    return false;
  }
  if (fromScreen === "MWValueForm") {
    if (
      newIndicators.megaWattValue?.toString() ===
        currentIndicators.megaWattValue?.toString() ||
      (!newIndicators.megaWattValue && !currentIndicators.megaWattValue)
    )
      return false;
    return true;
  }
}
